import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAddToBasket2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="add-to-basket-2"><path d="M8.25 3.75L6.35 8.5M15.75 3.75L17.65 8.5M10.25 20.25H4.75L2.75 8.75H21.25L20.7285 11.7485M13.75 18H17M17 18H20.25M17 18V14.75M17 18V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAddToBasket2;
